import { useEffect, useState } from 'react'

// Hook
export default function useOnScreenCallback(
  ref: React.MutableRefObject<HTMLElement | null>,
  callback: () => void,
  options?: IntersectionObserverInit
) {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = useState(false)
  const [callCount, setCallCount] = useState(0)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        setIntersecting(entry.isIntersecting)
      },
      {
        // default threshold, can be override through options
        threshold: 1.0,
        ...options
      }
    )
    if (ref.current) {
      observer.observe(ref.current)
    }
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current)
      }
    }
    // Update observer when the target element or root is changed
  }, [ref.current, options?.root])

  useEffect(() => {
    if (isIntersecting && callCount === 0) {
      callback()
      setCallCount(1)
    }
  }, [isIntersecting])
}
